import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationContext } from '@partner-global-ui/components';

import JobsTable from './cronJobsTable/JobsTable';
import { loadVIDSJobs, changeVIDSJobStatus } from '../../actions/venomJobsActions';

const VIDSJobsTable = () => {
  // Setup
  const title = 'VIDS Jobs Table';
  const dispatch = useDispatch();
  const notificationContext = useContext(NotificationContext);
  const { vidsCronJobs, loadingVIDSCronJobs } = useSelector((state) => state.cronJobs);
  const [currentSort, setCurrentSort] = useState({
    sortBy: 'jobCode', sortDir: 'asc',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    dispatch(loadVIDSJobs());
  }, []);

  const searchJobs = (term) => {
    setSearchTerm(term);
    dispatch(loadVIDSJobs(currentSort, term));
  };

  const setJobStatus = (id, status, revision) => {
    setIsOpen(true);
    dispatch(changeVIDSJobStatus(id, status, revision, notificationContext));
  };

  const sortJobs = (sortBy) => {
    const sortDir = currentSort.sortDir === 'asc' ? 'desc' : 'asc';
    setCurrentSort({
      sortBy, sortDir,
    });
    dispatch(loadVIDSJobs({ sortBy, sortDir }, searchTerm));
  };

  return (
    <JobsTable
      loading={loadingVIDSCronJobs}
      title={title}
      jobs={vidsCronJobs}
      setJobStatus={setJobStatus}
      currentSort={currentSort}
      sortJobs={sortJobs}
      searchTerm={searchTerm}
      searchJobs={searchJobs}
      isOpen={isOpen}
    />
  );
};

export default VIDSJobsTable;
